import { showOkCancel, showWarning, showYesNo } from "@omnia/shared/shell/msgbox/msgbox"
import { IOmniaShell, isNumber, omniaResolve, str } from "../../omnia"
import { IPlanUpdateModel } from "../../types"
import { PlanEditContext } from "./editContext"

export function askCommitOptions(ctxt: PlanEditContext, shell: IOmniaShell): ng.IPromise<IPlanUpdateModel> {

    const plan = ctxt.getUpdatedTargetModel(true)

    if (ctxt.newPlan || ctxt.applications.filter(a => !a.remove).every(a => a.isNew())) {
        return omniaResolve({ plan })
    }

    return shell.showComponentAsDialog("omnia-nutri-plan-confirm-dlg", {
        args: {
            ctxt,
            plan: ctxt.getUpdatedTargetModel(true),
            initialPlan: ctxt.initialPlan
        }
    }).then(model => <IPlanUpdateModel>model)

}

export function validateCommit(ctxt: PlanEditContext, shell: IOmniaShell): ng.IPromise<boolean> {

    return validateNvz(ctxt, shell)
        .then(r => r && validateBiomass(ctxt, shell))
        .then(r => r && validateFieldRemovals(ctxt, shell))

}

function validateBiomass(ctxt: PlanEditContext, shell: IOmniaShell) {

    const title = "Biomass options"
    const msg = (msg: string) => showWarning(shell, msg, title).then(_ => false)

    const isnum = (a: number) => isNumber(a) && !isNaN(a)

    const { target: plan, useBiomass: on, biomassOptions: options, cropping } = ctxt

    if (!(on && options)) {
        return omniaResolve(true)
    }

    const app = plan.Applications[0]

    if (!app) {
        return omniaResolve(false)
    }

    if (options.Auto) {
        if (!isnum(app.ProductRate)) {
            return msg("Please input either a product or a nutrient rate.")
        }
    }
    else {
        if (!(isnum(options.MinRate?.Product) && isnum(options.MaxRate?.Product))) {
            return msg("Please input a range of nutrient or product rates.")
        }
    }

    const croppingErrors = cropping
        .filter(c => c.selected && (!c.remove))
        .map(c => {

            if (!(c.biomassLayer || isnum(c.biomassAppRate?.Product))) {
                return c.description
            }

        })
        .filter(e => !!e)

    if (croppingErrors.length > 0) {
        const m = "<ul style='margin: 1em 0'>" + croppingErrors.map(e => "<li>&ndash;&nbsp;" + e + "</li>").join("")
        return msg("<p>The following fields are missing either a biomass layer, or a default rate:</p>" + m)
    }

    return omniaResolve(true)

}

function validateNvz(ctxt: PlanEditContext, shell: IOmniaShell): ng.IPromise<boolean> {

    const title = "NVZ Warning"

    const messages = ctxt.getNVZMessages(ctxt.cropping.filter(c => c.selected));

    if (messages && messages.error) {

        if (messages.canContinue && messages.canContinueForClosedPeriod) {

            const msg = "The application of nitrogen fertiliser is not permitted within the closed period, unless you have written advice from a FACTS-qualified advisor. Please confirm that you have got this written advice.";
            const msgConfirm = "I confirm"

            return showYesNo(shell, msg, title, msgConfirm, str.Cancel)

        } else if (!messages.canContinue) {

            const content = "This application is not permitted within the NVZ regulations and it is not possible to create the plan until the application has been changed."

            return showWarning(shell, content, title, str.Cancel).then(r => false)

        }

    }

    return omniaResolve(true)

}

function validateFieldRemovals(ctxt: PlanEditContext, shell: IOmniaShell): ng.IPromise<boolean> {

    if (!ctxt.newPlan) {

        const removed = ctxt.cropping.filter(c => c.remove);

        if (removed.length) {

            var title = "Confirm field removal";
            var content = removed.length.toString() + " field" + (removed.length > 1 ? "s" : "") + " will be removed from this plan<br><br>Do you want to continue?";

            return showOkCancel(shell, content, title);

        }

    }

    return omniaResolve(true)

}
